module.exports = __webpack_public_path__ + "img/faq.9e74ac5d.svg";